import { render, staticRenderFns } from "./YdaCv.vue?vue&type=template&id=16314c39&scoped=true&"
import script from "./YdaCv.vue?vue&type=script&lang=js&"
export * from "./YdaCv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16314c39",
  null
  
)

export default component.exports